export const STORAGE = {
	// FORM_DATA: 'formData',
	QUOTE: 'quote',
	SCREENSHOT: 'screenshotStep',
	ATTACHMENTS: 'attachments',

	STEP_STATUS: 'stepStatus',
	FILE_UPLOADED: 'fileUploaded',

	PAYMENT_ACCEPT_EXCEPTION: 'paymentAcceptedOrException',
	APPLY_PAYMENT_SUCCESS: 'applyOrPaymentComplete',
	iS_SUBMIT_FORM_PROCESSING: 'isSubmitFormProcessing',

	LOCALE: 'locale',
}

export const FILE = {
	POLICY_CERTIFICATE: 'PolicyCertificate.pdf',
	PREVIEW_FORM: 'ApplyOnline.pdf',
}

// for member card data
export const CountryIncludeLogo = ['Greece', 'Gibraltar', 'Spain', 'Portugal', 'Malta', 'Cyprus']
